import React, { Component } from "react";
import { apiCall_domainV2 } from "../../api";
import axios from "axios";
import toast from "react-hot-toast";

export default class WheelofFortune extends Component {
  constructor() {
    super();
    this.wheel = React.createRef();
  }
  state = {
    award: "",
  };
  spinWheel = () => {
    this.deg = Math.floor(5000 + Math.random() * 5000);
    this.wheel.current.style.transition = "all 10s ease-out";
    this.wheel.current.style.transform = `rotate(${this.deg}deg)`;

    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domainV2}/customer/market/spin`, { headers: headers })
      .then((res) => {
        this.setState({ award: res.data.gift });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  endSpinOfWheel = () => {
    this.wheel.current.style.transition = "none";
    const actualDeg = this.deg % 360;
    this.wheel.current.style.transform = `rotate(${actualDeg}deg)`;
  };
  copyToClipBoard = () => {
    try {
      navigator.clipboard.writeText(this.state.award);
      toast.success("کد کپی شد");
    } catch {
      toast.error("کد کپی نشد");
    }
  };
  tryAgain = () => {
    this.setState({ award: "" });
  };
  render() {
    const { handleWheelDisplay } = this.props;
    return (
      <div className={"wheelOfFortune"}>
        <div className='wheelHeader'>
          <span>چرخونک</span>
          <img
            src='/public/assets/icons/close.svg'
            onClick={() => handleWheelDisplay()}
            alt='close icon'
          />
        </div>
        <div className={"info"}>
          {this.state.award ? (
            <div className={"result"}>
              <div className={"expireDate"}>
                <span>تاریخ انقضاء</span>
                <span>
                  {this.state.award.expire_time}
                  <img src='/public/assets/coin.svg' alt='coin' />
                </span>
              </div>
              <div className='award'>
                شما برنده {this.state.award.title} شده اید
              </div>
              <span className={"description"}>
                کد تخفیف شما در تاریخچه بازارچه من ذخیره شده است
              </span>
              <div className='code'>{this.state.award.code}</div>
            </div>
          ) : (
            <>
              <div className={"points"}>
                <span>امتیاز شما</span>
                <span>
                  {this.props.currentPoints}
                  <img src='/public/assets/coin.svg' alt='coin' />
                </span>
              </div>
              <p className={"description"}>
                شانس خود را برای <span>برنده شدن یک جایزه</span> امتحان کنید
              </p>
              <span className={"requiredPoints"}>
                به ازای هر
                <span className={"point"}>{this.props.requiredPoints}</span>
                امتیاز شانس خود را امتحان کنید
              </span>
            </>
          )}
        </div>

        {this.state.award ? (
          <>
            <div className={"actions"}>
              <button className={"copy"} onClick={this.copyToClipBoard}>
                کپی کردن
              </button>
              <button className={"tryAgain"} onClick={this.tryAgain}>
                امتحان دوباره
              </button>
            </div>
          </>
        ) : (
          <>
            <div className={"wheel"}>
              <img
                className={"background"}
                onTransitionEnd={this.endSpinOfWheel}
                ref={this.wheel}
                src='/public/assets/img/CustomerClub/wheelOfFortune.svg'
              />
              <img
                className={"marker"}
                src='/public/assets/img/CustomerClub/wheelMarker.svg'
              />
            </div>
            <button className={"try"} onClick={this.spinWheel}>
              شانستو امتحان کن
            </button>
          </>
        )}
      </div>
    );
  }
}
